import type { Reducer } from 'redux';

import type { State } from './pipelineTypes';
import { ActionType } from './pipelineTypes';

export const initialState: State = {
  pipelines: [],
  isPerformingPipelineAction: false,
};

const pipelineReducer: Reducer<State> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.REQUEST_GET_ACCOUNT_PIPELINES:
      return {
        ...state,
        isPerformingPipelineAction: true,
      };
    case ActionType.GET_ACCOUNT_PIPELINES_FAILURE:
      return {
        ...state,
        isPerformingPipelineAction: false,
      };
    case ActionType.GET_ACCOUNT_PIPELINES_SUCCESS:
      return {
        ...state,
        pipelines: action.payload,
        isPerformingPipelineAction: false,
      };
    case ActionType.CLEAR_PIPELINES:
      return {
        ...state,
        pipelines: [],
        isPerformingPipelineAction: false,
      };
    default:
      return state;
  }
};

export default pipelineReducer;
